import { createRouter, createWebHistory } from "vue-router";
import store from "@/store";

import routerWeb from "./routerWeb";

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes: [...routerWeb],
});

router.beforeEach((to, from, next) => {
	document.title = to.meta.title;
	next();
});

router.afterEach((to) => {
	window.scrollTo(0, 0);
});

export default router;
